var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaymentCircleElement = function SvgPaymentCircleElement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 677,
    height: 677
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#38719f"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4,
    opacity: 0.352,
    transform: "translate(17.749 17.749)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320.751,
    cy: 320.751,
    r: 320.751,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.751,
    cy: 320.751,
    r: 318.751
  })), /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "8 5",
    strokeWidth: 2,
    opacity: 0.352
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 338.5,
    cy: 338.5,
    r: 338.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.5,
    cy: 338.5,
    r: 337.5
  })))));
};
export default SvgPaymentCircleElement;